// extracted by mini-css-extract-plugin
module.exports = {"grid12":"StandaloneText_grid12__lU_Fu","grid8":"StandaloneText_grid8__jpaPd","introColumns":"StandaloneText_introColumns__SY9gd"};